<template>
 <span :class="{ 'has-error' : $v.value.$error }">
  <span class="form__label" :class="{ 'error_input' : $v.value.$error }">
          <label :for="name" class="form__label-title">{{label}}<span v-if="this.required">*</span></label>
          <datepicker :input-class="'form__input'"
            :id="name"
            :name="name"
            :required="required"
            v-model.trim="customFormatter"
            :validators="validators"
            :disabledDates="dateInput.disabledDates"
            :language="currentLanguage"
            :placeholder="'dd/mm/yyyy'"
            :format="'dd/MM/yyyy'"
            :initialView="'year'"
            :typeable="true"
            @input="containsError($v.value)"></datepicker>
          <label v-if="this.required && $v.value.$dirty && !$v.value.required" class="form__label-title error">{{ $t('validations.required') }}</label>
      </span>
  </span>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import { en, ro, ru } from 'vuejs-datepicker/dist/locale';
import OnboardInputMixin from '@/mixins/OnboardInputMixin';

export default {
  name: 'OnboardDateInput',
  mixins: [OnboardInputMixin],
  components: { Datepicker },
  data() {
    return {
      dateInput: {
        disabledDates: {
          from: new Date(),
        },
      },
    };
  },
  computed: {
    currentLanguage() {
      switch (this.$store.state.currentLanguage) {
        case 'en':
          return en;
        case 'ru':
          return ru;
        case 'ro':
          return ro;
        default:
          return en;
      }
    },
    customFormatter: {
      get() {
        return this.$v.value.$model;
      },
      // setter
      set(newValue) {
        this.$v.value.$model = moment(newValue).format('LL');
      },
      // return moment(this.$v.value.$model).format('DD/MM/YYYY');
    },
  },
};
</script>
